// ============================================================
// Square Code · client-starter — Sentry instrumentation entry.
//
// Initialized only when VITE_SENTRY_DSN is set. The actual
// implementation lives in @square/shell so olivium-demo and any
// future app surface can reuse the exact same observability
// contract by calling initInstrumentation() at boot.
//
// Mode is derived from VITE_OLIVIUM_MODE so Sentry's `mode` tag
// matches the one the shell's hooks use.
//
// Required env vars (all optional, app boots without them):
//   VITE_SENTRY_DSN     — Sentry project DSN
//   VITE_APP_RELEASE    — release identifier (e.g. git sha)
//   VITE_APP_ENV        — production | staging | development
//   VITE_OLIVIUM_MODE   — live | demo
// ============================================================

import { initSentry } from '@square/shell'

export async function initInstrumentation(): Promise<void> {
  const env = import.meta.env as Record<string, string | undefined>
  const dsn = env.VITE_SENTRY_DSN
  if (!dsn) return

  // Release: prefer VITE_APP_RELEASE; otherwise fall back to the
  // Vite-exposed Vercel commit SHA so the browser bundle still
  // tags releases when the operator only sets VERCEL_GIT_COMMIT_SHA
  // (which Vercel injects automatically) and re-exposes it as
  // VITE_VERCEL_GIT_COMMIT_SHA at build time.
  const release =
    env.VITE_APP_RELEASE ||
    env.VITE_VERCEL_GIT_COMMIT_SHA ||
    undefined

  const environment =
    env.VITE_APP_ENV ||
    env.VITE_VERCEL_ENV ||
    'development'

  const ok = initSentry({
    dsn,
    release,
    environment,
    mode: env.VITE_OLIVIUM_MODE === 'live' ? 'live' : 'demo',
  })

  if (ok) {
    // eslint-disable-next-line no-console
    console.info('[client-starter] Sentry initialized')
  }
}
